// extracted by mini-css-extract-plugin
module.exports = {"container":"ServiceIconTextPair_container__ag8EI","iconWrapper":"ServiceIconTextPair_iconWrapper__tQL7d","title":"ServiceIconTextPair_title__2ofCt"};